import { render, staticRenderFns } from "./AppGebruikerEditTelefoonnummer.vue?vue&type=template&id=58fb6504&scoped=true&"
import script from "./AppGebruikerEditTelefoonnummer.vue?vue&type=script&lang=ts&"
export * from "./AppGebruikerEditTelefoonnummer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fb6504",
  null
  
)

export default component.exports